// removed by extract-text-webpack-plugin
module.exports = {"hidden":"bEwLu","visuallyhidden":"_2ac_8","hide-text":"_bq4U","center":"_2UTX2","noprint":"_3SHuv","headline":"_1F-n7"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-headline/styles/Headline_Factbox.scss
 ** module id = 944
 ** module chunks = 1
 **/